import React from 'react';

// Shared FPS color-threshold logic used by RigTelemetryCard, FeaturedRigCard,
// and RigDetail. Returns a Tailwind text-color class based on the FPS value:
//   >= 90  → emerald-400 (normal)
//   60–89 → amber-400 (warning)
//   < 60  → red-500 font-bold (critical / dropped frames)
//   null  → white/30 (-- FPS)
export function getFpsColorClass(fps) {
  if (fps == null) return 'text-white/30';
  if (fps < 60) return 'text-red-500 font-bold';
  if (fps < 90) return 'text-amber-400';
  return 'text-emerald-400';
}

export default function FpsBadge({ fps, className = '' }) {
  const colorCls = getFpsColorClass(fps);
  const label = fps != null ? `${Math.round(fps)} FPS` : '-- FPS';
  return (
    <span className={`font-mono text-xs ${colorCls} ${className}`.trim()}>
      {label}
    </span>
  );
}